"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleUrlUpdateError = void 0;
var _logger = require("../logger");
/* istanbul ignore file @preserve --log */

const queryStateLogger = _logger.mainLogger.createChild('QueryState');
const handleUrlUpdateError = (url, error) => {
  queryStateLogger.error(new Error(`Error updating URL: ${url} ${error?.message}`));
};
exports.handleUrlUpdateError = handleUrlUpdateError;
